/* eslint react/prop-types: 0 */
import React from 'react';
import { observer } from 'mobx-react';
import { Checkbox, Form, FormInstance } from 'antd';
import { CardLayout, Catcher, InputDebounce, InputNumberDebounce, cardLayoutOptions } from '../../';
import { EmailRecipientsEdit } from '../../EmailRecipients/EmailRecipientsEdit';
import { useProfileIsRight } from '../../../hooks';
import { apiMessagesGetFormRules, rulesIsNumber, rulesNumberMinMax } from '../../../middleware';
import { tF } from '../../../translate';

type IEditCompanyBillingInfo = {
    form: FormInstance;
};
export const EditCompanyBillingInfo: React.FC<IEditCompanyBillingInfo> = observer(
    ({ form }: IEditCompanyBillingInfo) => {
        const isRoot = useProfileIsRight('ROOT');
        const departmentTitle = tF('Billing to department');
        const emailTitle = tF('Billing to email');
        const vatNumberTitle = tF('Vat number');
        const vatPercentageTitle = tF('VAT percentage');
        const reverseChargeTitle = tF('Reverse charge applies');
        const paymentTermsTitle = tF('Payment terms');
        const billingCycleStartDayTitle = tF('Billing cycle start day');
        const validateBillingCycleStartDay = [rulesIsNumber, rulesNumberMinMax(1, 31), ...apiMessagesGetFormRules];
        return (
            <Catcher>
                <CardLayout
                    title={'Billing Information'}
                    idSpinners={['GET_COMPANY']}
                    columnOption={cardLayoutOptions.cardEditCompany}
                    dataTest={'EditCompanyBillingInfo'}
                >
                    <Form.Item
                        name="billingToDepartment"
                        label={departmentTitle}
                        rules={apiMessagesGetFormRules}
                        data-test={'EditCompanyBillingInfoDepartment'}
                    >
                        <InputDebounce
                            placeholder={departmentTitle}
                            data-test={'EditCompanyBillingInfoDepartmentInput'}
                        />
                    </Form.Item>
                    <Form.Item
                        name="vatNumber"
                        label={vatNumberTitle}
                        rules={apiMessagesGetFormRules}
                        data-test={'EditCompanyBillingInfoVatNumber'}
                    >
                        <InputDebounce
                            placeholder={vatNumberTitle}
                            data-test={'EditCompanyBillingInfoVatNumberInput'}
                        />
                    </Form.Item>
                    <Form.Item
                        name="vatPercentage"
                        label={vatPercentageTitle}
                        rules={apiMessagesGetFormRules}
                        data-test={'EditCompanyBillingInfoVatPercentage'}
                    >
                        <InputDebounce
                            placeholder={vatPercentageTitle}
                            data-test={'EditCompanyBillingInfoVatPercentageInput'}
                        />
                    </Form.Item>
                    <Form.Item
                        name="reverseChargeApplies"
                        valuePropName="checked"
                        rules={apiMessagesGetFormRules}
                        data-test={'EditCompanyBillingInfoReverseChargeApplies'}
                    >
                        <Checkbox data-test={'EditCompanyBillingInfoReverseChargeAppliesCheckbox'}>
                            {reverseChargeTitle}
                        </Checkbox>
                    </Form.Item>
                    <Form.Item
                        name="paymentTerms"
                        label={paymentTermsTitle}
                        rules={apiMessagesGetFormRules}
                        data-test={'EditCompanyBillingInfoPaymentTerms'}
                    >
                        <InputNumberDebounce
                            type="number"
                            min={0}
                            step={1}
                            placeholder={paymentTermsTitle}
                            data-test={'EditCompanyBillingInfoPaymentTermsInput'}
                        />
                    </Form.Item>
                    {isRoot ? (
                        <Form.Item
                            name="billingCycleStartDay"
                            label={billingCycleStartDayTitle}
                            rules={validateBillingCycleStartDay}
                            data-test={'EditCompanyBillingInfoBillingCycleStartDay'}
                        >
                            <InputNumberDebounce
                                type="number"
                                min={1}
                                max={31}
                                step={1}
                                placeholder={billingCycleStartDayTitle}
                                data-test={'EditCompanyBillingInfoBillingCycleStartDayInput'}
                            />
                        </Form.Item>
                    ) : null}
                    {emailTitle}
                    <EmailRecipientsEdit name={'billingEmails'} form={form} />
                </CardLayout>
            </Catcher>
        );
    },
);
